module.exports = __webpack_public_path__ + "static/media/weather.e9419437.png";